var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "row checkboxGroup",
      attrs: { id: _vm.model.componentSetting.id }
    },
    [
      _c("div", { staticClass: "col-lg-1" }, [
        _vm._v(_vm._s(_vm.model.componentSetting.value))
      ]),
      _c("div", { staticClass: "col-lg-10" }, [
        _c("div", { staticClass: "white-background box-shadow p-4 mb-4" }, [
          _c("h3", { staticClass: "mb-4" }, [
            _vm._v(_vm._s(_vm.model.componentSetting.title))
          ]),
          _c("p", { staticClass: "bodytext" }, [
            _vm._v(_vm._s(_vm.model.componentSetting.description))
          ]),
          _c(
            "div",
            { staticClass: "checkbox-buttons" },
            _vm._l(_vm.model.componentSetting.items, function(item) {
              return item.isEnabled
                ? _c("label", { staticClass: "form-check-label" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.data.model[item.id],
                          expression: "data.model[item.id]"
                        }
                      ],
                      class: ["form-check-input checkbox", _vm.refresh],
                      attrs: { type: "checkbox", id: item.id, name: item.id },
                      domProps: {
                        value: item.id,
                        checked: Array.isArray(_vm.data.model[item.id])
                          ? _vm._i(_vm.data.model[item.id], item.id) > -1
                          : _vm.data.model[item.id]
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.data.model[item.id],
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = item.id,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.data.model,
                                  item.id,
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.data.model,
                                  item.id,
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.data.model, item.id, $$c)
                          }
                        }
                      }
                    }),
                    _c("span", { staticClass: "mdi mdi-name check-span" }),
                    _c("span", { staticClass: "checkbox-text mb-4" }, [
                      _vm._v(
                        _vm._s(item.title) + " " + _vm._s(item.description)
                      )
                    ])
                  ])
                : _vm._e()
            }),
            0
          )
        ])
      ]),
      _c("div", { staticClass: "col-lg-1" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }